var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMachineIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.15 18.35V16.95L19.9 15.75L20.2999 15.45C20.6999 15.15 20.95 14.7 20.95 14.2V11.1C20.95 10.7 20.7999 10.3 20.5 10.05L18.35 7.85C18.15 7.65 17.9 7.45 17.65 7.3V5.7L9.44995 3.5L8.04995 4.45L6.99995 4.15V2.75H4.24995L1.94995 6.1L3.04995 7.7L3.99995 12.4C4.04995 12.7 4.19995 13.05 4.34995 13.3L5.84995 15.6L2.99995 18.85V20.75H4.99995V21.25H5.99995V19.75H4.19995L5.84995 18.05L11.15 18.5C11.1 18.65 11.1 18.85 11.1 19C11.1 20.1 12 21 13.1 21C14.2 21 15.1 20.1 15.1 19C15.1 17.9 14.2 17 13.1 17C12.6 17 12.1 17.2 11.75 17.5L5.94995 17L6.64995 16.2H19.1L20.25 17.3V18.75L21.1 19.55V20.25H16V21.25H22V19.15L21.15 18.35ZM9.64995 4.55L16.75 6.4V6.85L9.29995 4.8L9.64995 4.55ZM3.64995 6.8L3.19995 6.1L4.79995 3.75H5.99995V4.35L3.64995 6.8ZM4.94995 12.2L4.09995 7.75L6.69995 5.1L16.6 7.85C17 7.95 17.4 8.2 17.7 8.5L19.85 10.7C19.95 10.8 20 10.95 20 11.1V14.2C20 14.4 19.9 14.55 19.75 14.65L19.15 15.05L18.85 15.25H6.79995L5.19995 12.75C5.09995 12.6 4.99995 12.4 4.94995 12.2ZM13.05 18.05C13.6 18.05 14.05 18.5 14.05 19.05C14.05 19.6 13.6 20.05 13.05 20.05C12.5 20.05 12.05 19.6 12.05 19.05C12.05 18.5 12.5 18.05 13.05 18.05Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMachineIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Machine_Icon.a4003b713ce761259dad0f9488a2035e.svg";